import React from 'react'
import Select from 'react-select'
import { isEqual } from 'lodash'
import { fnum, sortOpts } from '../../utils/utils'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import DeleteConfirmation from '../ui/DeleteConfirmation'
import PRSAddPmntForm from '../prs/PRSAddPmntForm'
import Form from '../ui/Form'

class ExpenseListItem extends Form {

  constructor(props){
    super(props);
    this.state = {
      editing: false,
      adding: false,
      delConf: false,
      data: props.data,
      errors: {}
    }
  }

  handleAddClick = (e) => {
    e.preventDefault();
    this.setState({adding: true});
  }

  cancelAdd = () => {
    this.setState({adding: false});
  }

  saveExpense = () => {
    const { data } = this.state;
    if(isEqual(this.props.data, data)){
      this.cancelEditing();
    }
    else {
      const toSend = this.props.data.post_seller !== data.post_seller ? {
        ...data,
        update_pmnts_seller: 1
      } : data;
      if (this.props.data.post_payer !== data.post_payer) toSend.update_pmnts_payer = 1;
      this.props.editExpense(toSend, (err) => {
        if(err){
          this.setState({
            errors: err
          });
          return false;
        }
        this.cancelEditing();
      });
    }
  }

  deleteItem = () => {
    this.props.editExpense({
      ...this.props.data,
      post_active: 0
    }, this.cancelEditing);
  }

  render() {
    const { srvcs, srvgs, comps, data, comprights, settings, pmnts } = this.props;
    const { editing, adding, data: nData, errors } = this.state;
    const postSum = fnum(("" + nData.post_price).replace(',','.') *
      ("" + nData.post_qntt).replace(',','.'));
    const { srvc_type } = srvcs[data.post_srvc_id];
    const postPayedColor = data.post_payed ? 'green' : (
      data.post_bdate <= moment().format('Y-MM-DD') ? 'red' : ''
    );
    const postPayedLabel = srvc_type === -1 ?
      <div style={{color: postPayedColor}}>
        {data.post_payed ? 'Оплачено' : 'Не оплачено'}
      </div>
      : [];
    const postPayedInput = srvc_type === -1 ?
      <div className="checkbox">
        <label>
          <input type="checkbox" checked={nData.post_payed}
            name="post_payed" onChange={this.handleChBox} /> Оплачено
        </label>
      </div>
      : [];

    const delConf = this.state.delConf ?
      <DeleteConfirmation
        onDelete={this.deleteItem}
        onCancel={this.toggleDelConf}
      />
      :
      '';

    var srvcsOpt = [];
    for (var key in srvcs){
      if(srvcs.hasOwnProperty(key) && ((srvcs[key].srvc_active === 1
        && srvcs[key].srvc_expense === 1) || parseInt(key,10) === data.post_srvc_id)) {
        srvcsOpt.push({value:srvcs[key].srvc_id,label:srvcs[key].srvc_desc});
      }
    }
    srvcsOpt.sort(sortOpts);

    var compsOpt = [];
    var comps1Opt = [];
    for (key in comps){
      if(comps.hasOwnProperty(key) && comps[key].comp_active) {
        if(comps[key].comp_own && comprights.indexOf(parseInt(key,10))!==-1){
          comps1Opt.push({value:comps[key].comp_id,label:comps[key].comp_desc});
        }
        if(comps[key].comp_expense){
          compsOpt.push({value:comps[key].comp_id,label:comps[key].comp_desc});
        }
      }
    }
    compsOpt.sort(sortOpts);
    comps1Opt.sort(sortOpts);

    let pmntSum = 0;
    pmnts.forEach(pmnt => {
      pmntSum += pmnt.post_price * pmnt.post_qntt;
    });

    if(editing){
      return(
        <tr>
          <td>
            {delConf}
            <div className="form-group">
              <Select
                clearable={false}
                options={srvcsOpt}
                value={nData.post_srvc_id}
                onChange={e => this.updateSelect(e,'post_srvc_id')}
                placeholder="Услуга"
              />
            </div>
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.post_desc}
                name="post_desc"
                onChange={this.updateInput}
                placeholder="Описание"
              />
            </div>
            <div className="form-inline">
              <button  type="button" className="btn btn-success"
                onClick={this.saveExpense}  title="Сохранить">
                <span className="glyphicon glyphicon-save"></span>
              </button>{" "}
              <button type="button" className="btn btn-default"
                onClick={this.cancelEditing} title="Отменить">
                <span className="glyphicon glyphicon-remove"></span>
              </button>{" "}
              <button type="button" className="btn btn-danger"
                onClick={this.toggleDelConf} title="Удалить">
                <span className="glyphicon glyphicon-trash"></span>
              </button>
            </div>
            {errors.form && <div className="alert alert-danger">{errors.form}</div>}
          </td>
          <td>
            <input type="text"
              className="form-control"
              value={nData.post_price}
              name="post_price"
              onChange={this.updateInput}
              placeholder="Цена" title="Цена"
            />
            <center>x</center>
            <input type="text"
              className="form-control"
              value={nData.post_qntt}
              name="post_qntt"
              onChange={this.updateInput}
              placeholder="Кол-во" title="Кол-во"
            />
            <center>= {postSum}</center>
          </td>
          <td>
            <DatePicker
              className="form-control"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              selected={moment(nData.post_bdate)}
              onChange={e => this.updateDate(e, 'post_bdate')}
            />
          </td>
          <td>
            <Select
              clearable={false}
              options={compsOpt}
              value={nData.post_seller}
              onChange={e => this.updateSelect(e,'post_seller')}
              placeholder="Поставщик"
            />
          <span>Плательщик:</span>
          <Select
            clearable={false}
            options={comps1Opt}
            value={nData.post_payer}
            onChange={e => this.updateSelect(e,'post_payer')}
            placeholder="Плательщик"
          />
          </td>
          <td>
            {srvgs[srvcs[nData.post_srvc_id].srvc_srvg_id].srvg_desc}
          </td>
          <td>
            {postPayedInput}
            <textarea type="text"
              className="form-control"
              value={nData.post_note || ''}
              name="post_note"
              onChange={this.updateInput}
              placeholder="Заметка"
              title="Заметка"
            />
          </td>
        </tr>
      );
    }
    return (
      <tr onClick={this.startEditing}>
        <td className="hover-popup-container">
          {srvcs[data.post_srvc_id].srvc_desc+((""+data.post_desc) ? ": "+data.post_desc : "")}
          <div onClick={e => e.stopPropagation()}>
            <div
              className="hover-popup"
            >
              <button
                className="btn btn-success"
                onClick={this.handleAddClick}
              >
                Добавить оплату
              </button>
            </div>
            {adding && (
              <PRSAddPmntForm
                data={{
                  post_srvc_id: settings.default_expense_pmnt_srvc_id,
                  post_desc: '',
                  post_order_id: 0,
                  post_price: data.post_price * data.post_qntt - pmntSum,
                  post_qntt: 1,
                  post_note: "",
                  post_active: 1,
                  post_seller: data.post_seller,
                  post_payer: data.post_payer,
                  post_bdate: moment().format('Y-MM-DD'),
                  post_avans: 1,
                  post_payed: 0,
                  post_link: data.post_id
                }}
                cancelAdd={this.cancelAdd}
                updtBlnc={() => {}}
                editPost={this.props.editExpense}
                srvcs={srvcs}
              />
            )}
          </div>
        </td>
        <td className="text-right">{fnum(data.post_price*data.post_qntt)}</td>
        <td>{moment(data.post_bdate).format('L')}</td>
        <td>{comps[data.post_seller].comp_desc}</td>
        <td>{srvgs[srvcs[data.post_srvc_id].srvc_srvg_id].srvg_desc}</td>
        <td>{postPayedLabel}{data.post_note}</td>
      </tr>
    );

  }
}

export default ExpenseListItem;



// WEBPACK FOOTER //
// ./src/components/expense/ExpenseListItem.js